/**
 * Notice: ideally this should be in the shared directory, but I cannot get it to work.
 * I assume because the root web package is uses xstate5, but Admin is using xstate4, with a
 * specific link to enable xstate5. Once all existing state machines are using xstate5, this
 * can be moved to the shared directory.
 */

import { assign, fromPromise, setup } from "xstate5";

type Context = {
	error?: string;
	permissions: Record<string, boolean>;
	requiredPermission: string[];
};

type Events =
	| {
			type: "retry";
	  }
	| {
			type: "done.invoke.fetch";
			data: Context["permissions"];
	  }
	| {
			type: "error.platform.fetch";
			data: Error;
	  };

type CreatePermissionsActorInput = {
	requiredPermission: Context["requiredPermission"];
	fetchPermissions: (
		requiredPermission: Context["requiredPermission"],
	) => Promise<Record<string, boolean>>;
};

export function createPermissionsStateMachine({
	requiredPermission,
	fetchPermissions,
}: CreatePermissionsActorInput) {
	// Assume all permissions are false by default
	const permissions: Context["permissions"] = {};
	for (const permission of requiredPermission) {
		permissions[permission] = false;
	}

	return setup({
		types: {
			context: {} as Context,
			events: {} as Events,
		},
		actors: {
			fetch: fromPromise(({ input }: { input: string[] }) =>
				fetchPermissions(input),
			),
		},
		actions: {
			setPermissions: assign({
				permissions: (_, params: Context["permissions"]) => params,
			}),
			setError: assign({
				error: (_, params: Error) => params.message,
			}),
		},
	}).createMachine({
		id: "getPermissions",
		context: {
			permissions,
			requiredPermission,
		},
		initial: "loading",
		states: {
			loading: {
				invoke: {
					id: "fetch",
					src: "fetch",
					input: ({ context }) => context.requiredPermission,
					onDone: {
						target: "success",
						actions: {
							type: "setPermissions",
							params: ({ event }) => event.output,
						},
					},
					onError: {
						target: "error",
						actions: {
							type: "setError",
							params: ({ event }) => event.error as Error,
						},
					},
				},
			},
			success: {
				type: "final",
			},
			error: {
				on: {
					retry: "loading",
				},
			},
		},
		output: ({ context }) => context.permissions,
	});
}
